import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
    getEventbriteUrl,
    getExpressPaymentMethodNameForLegalText,
} from '../utils';

const LegalText: FunctionComponent<{
    isAppRebrandActive: boolean;
    locale: string;
    showingApplePay: boolean;
    showingPaypal: boolean;
    showingGooglePay: boolean;
    isScalableExpressCheckoutEnabled: boolean;
    styles: Record<string, string>;
}> = ({
    isAppRebrandActive,
    locale,
    showingApplePay,
    showingPaypal,
    showingGooglePay,
    isScalableExpressCheckoutEnabled,
    styles,
}) => {
    const urlPrefix = getEventbriteUrl(locale);
    const paymentMethodToDisplay = getExpressPaymentMethodNameForLegalText({
        showingApplePay,
        showingPaypal,
        showingGooglePay,
    });

    const tosLinkText = isScalableExpressCheckoutEnabled
        ? gettext('Terms of Service')
        : gettext('Eventbrite Terms of Service');

    const tosLink = `<a href="${urlPrefix}/tos" class="eds-link" target="_blank" id="tos" rel="noopener noreferrer">${tosLinkText}</a>`;

    const tosText = gettext(
        'By clicking Buy with %(paymentMethodToDisplay)s, I agree to the %(tosLink)s.',
        { paymentMethodToDisplay, tosLink },
    ).toString();

    const tosCss = classNames(
        { 'eds-text-color--ui-800': !isAppRebrandActive },
        [styles.legalText],
    );

    return (
        <p
            className={tosCss}
            data-testid="express-checkout-legal-text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: tosText,
            }}
        />
    );
};

export default LegalText;
